import AccountShell
  from "./accountShell";

export default function Privacy() {
  return (
    <AccountShell
      title="Chính sách bảo mật & Quyền riêng tư"
      description="Thông tin về dữ liệu và tài khoản"
    >
      <div
        className="
          text-[14px]
          leading-7
          text-slate-600
          space-y-4
        "
      >
        <p>
          Cửa Hàng Y Khoa sử dụng thông tin
          tài khoản để phục vụ đăng nhập,
          xử lý đơn hàng, cung cấp quyền
          truy cập sách và tài liệu, hỗ trợ
          khách hàng và vận hành các tiện ích.
        </p>

        <p>
          Người dùng có thể cập nhật thông tin
          cá nhân và địa chỉ nhận hàng trong
          khu vực Tài khoản.
        </p>

        <p>
          Mật khẩu không được hiển thị trong
          trang tài khoản. Việc thay đổi mật
          khẩu được thực hiện qua chức năng
          Đổi mật khẩu.
        </p>

        <p>
          Khi cần hỗ trợ liên quan đến dữ liệu
          cá nhân hoặc quyền riêng tư, vui lòng
          sử dụng Trung tâm trợ giúp.
        </p>
      </div>
    </AccountShell>
  );
}
